import { useEffect, useState } from "react";
import { AppBar, Toolbar, Grid, useMediaQuery, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "../../../app/theme/colors";
import { useSubHeaderStyles } from "./subHeaderStyles";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import AppButton from "../../../components/appButton/appButton";
import { routes } from "../../../app/router/routes";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import EastIcon from "@mui/icons-material/East";

const GradientAppBar = styled(AppBar)(({ theme }) => ({
  alignItems: "center",
  backgroundColor: colors.subHeader,
  backgroundPosition: "right",
}));

const SubHeader = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const { classes } = useSubHeaderStyles();

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const [buttonText, setButtonText] = useState(t("subheader.callNow"));
  const [phoneLinkMobile, setPhoneLinkMobile] = useState("tel:+38751255310");

  const handleClick = () => {
    setButtonText("+387 51 255 310");
    setTimeout(() => {
      setButtonText(t("subheader.callNow"));
    }, 5000);
  };

  useEffect(() => {
    setButtonText(t("subheader.callNow"));
  }, [t]);

  const handleAdvertisementPage = () => {
    navigate(routes.advertisementRequest);
  };

  return (
    <GradientAppBar position="static">
      <Toolbar className={classes.toolbar} id="subHeader_toolbar">
        <Grid container spacing={2}>
          <Grid item md={6} xs={6} className={classes.phoneSectionWrapper}>
            <AppButton
              id="subHeader_button_call"
              startIcon={<PhoneInTalkIcon />}
              label={buttonText}
              color={colors.primary}
              hover={colors.primary}
              href={phoneLinkMobile}
              onClick={handleClick}
              width={isMobile ? "100%" : "30%"}
            />
          </Grid>
          <Grid item md={6} xs={6} className={classes.marketingButtonSection}>
            <AppButton
              id="subHeader_button_order"
              endIcon={<EastIcon />}
              label={t("buttons.order")}
              color={colors.primary}
              hover={colors.primary}
              width={isMobile ? "100%" : "30%"}
              onClick={handleAdvertisementPage}
            />
          </Grid>
        </Grid>
      </Toolbar>
    </GradientAppBar>
  );
};

export default SubHeader;
